import React, { Component } from 'react';

class Footer extends Component {
	render() {
		return (
			<footer>
				<div className="container-fluid">
					<div className="row footer__widgets">
						<div className="col-sm-8">
							<img className="img-fluid footer__logo" src="../images/logo-white.svg" />
							<p>Want to stay updated with us?</p>
							<ul className="inline">
								<li>
									<a href="">
										<img src="../images/twit.svg" alt=""/>
									</a>
								</li>
								<li>
									<a href="">
										<img src="../images/fb.svg" alt=""/>
									</a>
								</li>
								<li>
									<a href="">
										<img src="../images/insta.svg" alt=""/>
									</a>
								</li>
								<li>
									<a href="">
										<img src="../images/linkd.svg" alt=""/>
									</a>
								</li>
								<li>
									<a href="">
										<img src="../images/pin.svg" alt=""/>
									</a>
								</li>
								<li>
									<a href="">
										<img src="../images/ytube.svg" alt=""/>
									</a>
								</li>
							</ul>
						</div>
						<div className="col-sm-4 mt-sm-0 mt-4 pl-5 pl-sm-0">
							<div className="row">
								<div className="col-6">
									<ul className="list">
										<li><a href="">Skin Assessment</a></li>
										<li><a href="">Log In</a></li>
										<li><a href="">Ingridients</a></li>
										<li><a href="">Products</a></li>
										<li><a href="">Blog</a></li>
									</ul>
								</div>
								<div className="col-6">
									<ul className="list">
										<li><a href="">Who We Are</a></li>
										<li><a href="">Career</a></li>
										<li><a href="">Reviews</a></li>
										<li><a href="">Contact</a></li>
										<li><a href="">FAQs</a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<hr color="white"/>
				<div className="footer__copyrights container-fluid">
					<div className="row">
						<div className="col-12">
							<ul className="inline">
								<li><a href="">Privacy Policy</a></li>
								<li><a href="">Terms of Service</a></li>
								<li>© 2020 Yours Skincare. All rights reserved.</li>
							</ul>
						</div>
					</div>
					
				</div>
			</footer>
		);
	}
}

export default Footer;